import React from 'react'

export const UNSAVED_MESSAGE = 'Hay cambios sin guardar en este control. Si continuas, se perderan. ¿Quieres salir sin guardar?'
export const UnsavedChangesContext = React.createContext({ setDirty: () => {}, confirmDiscard: () => true })

export const useUnsavedChanges = (dirty) => {
  const { setDirty } = React.useContext(UnsavedChangesContext)
  React.useEffect(() => {
    setDirty(dirty)
    return () => setDirty(false)
  }, [dirty, setDirty])
  return React.useCallback(() => !dirty || window.confirm(UNSAVED_MESSAGE), [dirty])
}
